import axiosService from './axios.service';
import ResponseService from './response.service';

const details = async ({ voucher_code, project_id, user_id }) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'voucher/apply/',
      params: { voucher_code, project_id, user_id },
      isAuthorized: true,
      allowRequestCancellation: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const VouchersService = {
  details,
};

export default VouchersService;
